import {connect} from 'react-redux';
import React, {Component} from 'react';

import Info from '../Info';
import Owner from '../Owner';
// Временно спрятанные отзывы
import Reviews from "../Reviews";
import Location from "../Location";
import Description from '../Description';
import Convenience from '../Convenience';
import * as ObjectUtils from '../../../utils/Property';
import * as ConfigurationUtils from '../../../utils/Configuration';

import depositSVG from '../../../static/img/objects/other/deposit.svg';
import minDaysSVG from '../../../static/img/objects/other/minDays.svg';
import cleaningSVG from '../../../static/img/objects/other/cleaning.svg';
import excessFareSVG from '../../../static/img/objects/other/excessFare.svg';
import areaSVG from '../../../static/img/objects/generalInformation/area.svg';
import terraceSVG from '../../../static/img/objects/generalInformation/terrace.svg';
import countBedsSVG from '../../../static/img/objects/generalInformation/countBeds.svg';
import countGuestSVG from '../../../static/img/objects/generalInformation/countGuest.svg';
import typeApartmentSVG from '../../../static/img/objects/generalInformation/typeApartment.svg';
import countBedroomsSVG from '../../../static/img/objects/generalInformation/countBedrooms.svg';
import countBathroomsSVG from '../../../static/img/objects/generalInformation/countBathrooms.svg';
import refSVG from "../../../static/img/objects/generalInformation/ref.svg";

class MainContainer extends Component {
    getGeneralInformationInfo() {
        const {i18n} = this.props;
        const props = this.props.objectPage.currentObject.props;
        let info = {
            title: i18n['objectPage.generalInformation'],
            items: []
        };


        let objectId = this.props.objectPage.currentObject.id;
        let item = {
            imgURL: refSVG,
            name: i18n['objectPage.ref'],
            value: "Ref. " + objectId.substr(objectId.length - 7)
        };
        info.items.push(item);

        if (props.typeApartment !== undefined && props.typeApartment !== null && props.typeApartment.length > 0) {
            let item = {
                imgURL: typeApartmentSVG,
                name: i18n['objectPage.typeApartment'],
                value: ConfigurationUtils.getTypeTitleByValue(props.typeApartment, this.props.configuration.object.typeApartmentsRent)
            };
            info.items.push(item);
        }
        if (props.area !== undefined && props.area !== null && props.area > 0) {
            let item = {
                imgURL: areaSVG,
                name: i18n['objectPage.area'],
                value: `${props.area} ${i18n['objectPage.areaUnit']}`
            };
            info.items.push(item);
        }
        if (props.terrace !== undefined && props.terrace !== null && props.terrace > 0) {
            let item = {
                imgURL: terraceSVG,
                name: i18n['objectPage.terrace'],
                value: `${props.terrace} ${i18n['objectPage.areaUnit']}`
            };
            info.items.push(item);
        }
        if (props.countBeds !== undefined && props.countBeds !== null && props.countBeds > 0) {
            let item = {
                imgURL: countBedsSVG,
                name: i18n['objectPage.countBeds'],
                value: props.countBeds
            };
            info.items.push(item);
        }
        if (props.countBedrooms !== undefined && props.countBedrooms !== null && props.countBedrooms > 0) {
            let item = {
                imgURL: countBedroomsSVG,
                name: i18n['objectPage.countBedrooms'],
                value: props.countBedrooms
            };
            info.items.push(item);
        }
        if (props.countBathrooms !== undefined && props.countBathrooms !== null && props.countBathrooms > 0) {
            let item = {
                imgURL: countBathroomsSVG,
                name: i18n['objectPage.countBathrooms'],
                value: props.countBathrooms
            };
            info.items.push(item);
        }
        if (props.countGuest !== undefined && props.countGuest !== null && props.countGuest > 0) {
            let item = {
                imgURL: countGuestSVG,
                name: i18n['objectPage.countGuest'],
                value: props.countGuest
            };
            info.items.push(item);
        }
        return info;
    }

    getOtherInfo() {
        const {i18n} = this.props;
        const price = this.props.objectPage.currentObject.price;
        let info = {
            title: i18n['objectPage.other'],
            items: []
        };

        if (price.deposit !== undefined && price.deposit !== null && price.deposit > 0) {
            let item = {
                imgURL: depositSVG,
                name: `${i18n['objectPage.deposit']}, ${price.currencyMark}`,
                value: price.deposit
            };
            info.items.push(item);
        }
        if (price.excessFare !== undefined && price.excessFare !== null && price.excessFare > 0) {
            let item = {
                imgURL: excessFareSVG,
                name: `${i18n['objectPage.excessFare']}, ${price.currencyMark}`,
                value: price.excessFare
            };
            info.items.push(item);
        }
        if (price.cleaning !== undefined && price.cleaning !== null && price.cleaning > 0) {
            let item = {
                imgURL: cleaningSVG,
                name: `${i18n['objectPage.cleaning']}, ${price.currencyMark}`,
                value: price.cleaning
            };
            info.items.push(item);
        }
        if (price.minDays !== undefined && price.minDays !== null && price.minDays > 0) {
            let item = {
                imgURL: minDaysSVG,
                name: i18n['objectPage.minDays'],
                value: price.minDays
            };
            info.items.push(item);
        }
        return info;
    }

    getConvenience() {
        const {i18n, amenities, amenitiesConf} = this.props;
        let convenience = {
            title: i18n['objectPage.convenience'],
            items: []
        };

        /*eslint-disable*/
        amenities.forEach(a => {
            let item = {
                imgURL: ObjectUtils.getImgURLForConvenience(a),
                name: ConfigurationUtils.getTypeTitleByValue(a, amenitiesConf)
            };
            convenience.items.push(item);
        });
        /*eslint-enable*/

        return convenience;
    }

    getRentComment() {
        const {code, translates, isShowOriginal, rentComment} = this.props;
        let response;

        if (translates !== undefined && translates !== null && code !== undefined) {
            if (isShowOriginal) {
                response = rentComment;
            } else {
                response = ObjectUtils.getTranslateByCode(translates, code).rentComment;
            }
        } else if (rentComment !== undefined && rentComment !== null) {
            response = rentComment;
        } else {
            response = '';
        }
        return response;
    }

    render() {
        const {i18n, license, amenities, amenitiesConf, cancellationRule, typeRuleReservations} = this.props;

        return (
            <div className="main-container">
                <Owner/>

                <div className="rent-nav">
                    <a href="#description" className="active">
                        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="54" viewBox="0 0 55 54">
                            <path fill="#ccc"
                                  d="M45.34 22L55 16.51 27.5.99 0 16.51 9.66 22 0 27.45l9.66 5.49L0 38.39 27.5 54 55 38.39l-9.66-5.45L55 27.45zM27.5 3.28l23.45 13.24L27.5 29.83 4.05 16.52zM11.7 23.15l15.81 8.97 15.82-8.97 7.63 4.31L27.5 40.77 4.05 27.46zM50.95 38.4L27.5 51.71 4.05 38.4l7.64-4.31 15.81 8.98 15.82-8.98z"/>
                        </svg>
                        <span>{i18n['objectPage.overview']}</span>
                    </a>
                    <a href="#convenience">
                        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="42" viewBox="0 0 59 42">
                            <path fill="#ccc"
                                  d="M55.95 18.19V3.62c0-2-1.62-3.62-3.6-3.62H6.64c-1.98 0-3.6 1.62-3.6 3.62v14.57A3.6 3.6 0 0 0 0 21.74v9.02c0 .63.51 1.14 1.14 1.14h1.22v5.62c0 .63.5 1.14 1.13 1.14h2.06v2.2a1.14 1.14 0 1 0 2.28 0v-2.2h43.34v2.2a1.14 1.14 0 1 0 2.28 0v-2.2h2.05c.63 0 1.14-.51 1.14-1.14V31.9h1.22c.63 0 1.14-.51 1.14-1.14v-9.02a3.6 3.6 0 0 0-3.05-3.55zM5.32 3.62c0-.74.6-1.34 1.34-1.34h45.68c.74 0 1.34.6 1.34 1.34v14.53h-4c.8-.86 1.6-1.76 2.44-2.73.38-.42.38-1.06 0-1.49a92.27 92.27 0 0 0-9.83-9.85 1.12 1.12 0 0 0-1.5 0 93.2 93.2 0 0 0-9.82 9.85 1.13 1.13 0 0 0 0 1.49c.83.97 1.64 1.87 2.44 2.73h-7.82c.8-.86 1.6-1.76 2.44-2.73.38-.42.38-1.06 0-1.49a93.11 93.11 0 0 0-9.83-9.85 1.12 1.12 0 0 0-1.5 0 93.2 93.2 0 0 0-9.82 9.85 1.13 1.13 0 0 0 0 1.49c.83.97 1.64 1.87 2.44 2.73h-4zm31.23 14.53c-1.05-1.08-2.1-2.22-3.21-3.47a88.91 88.91 0 0 1 8.2-8.23 88.91 88.91 0 0 1 8.21 8.23c-1.1 1.25-2.16 2.39-3.2 3.47zm-24.1 0c-1.04-1.08-2.1-2.22-3.2-3.47a88.79 88.79 0 0 1 8.2-8.23 88.91 88.91 0 0 1 8.21 8.23c-1.1 1.25-2.16 2.39-3.2 3.47zm41.92 18.23H4.63V31.9h49.74zm-52.1-6.76v-7.88c0-.72.6-1.31 1.32-1.31H55.4c.73 0 1.31.59 1.31 1.31v7.88z"/>
                        </svg>
                        <span>{i18n['objectPage.facilities']}</span>
                    </a>

                    <a href="#reviews">
                        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="50" viewBox="0 0 55 50">
                            <path fill="#ccc"
                                  d="M9.17 20.88h11.91a.9.9 0 0 0 0-1.81H9.17a.9.9 0 1 0 0 1.81zM33 24.51H9.17c-.51 0-.92.41-.92.91s.41.91.92.91H33c.5 0 .92-.41.92-.91s-.41-.91-.92-.91zm0 5.45H9.17c-.51 0-.92.41-.92.91s.41.91.92.91H33c.5 0 .92-.41.92-.91s-.41-.91-.92-.91zM49.57.06L18.27 0c-3 0-5.44 2.41-5.44 5.38v4.66l-7.4.01c-3 0-5.43 2.42-5.43 5.39v19.19a5.41 5.41 0 0 0 5.44 5.38H11v9.08a.9.9 0 0 0 .92.91c.25 0 .5-.1.67-.3l8.9-9.69 15.24-.06c3 0 5.44-2.41 5.44-5.38v-.11l4.82 5.26a.93.93 0 0 0 1 .23.9.9 0 0 0 .6-.84v-9.08h.97c3 0 5.44-2.42 5.44-5.39V5.45A5.42 5.42 0 0 0 49.57.06zm-9.24 34.51a3.59 3.59 0 0 1-3.6 3.56l-15.65.07c-.26 0-.5.11-.68.29l-7.57 8.25V39.1c0-.5-.4-.9-.91-.9H5.44c-2 0-3.6-1.6-3.6-3.57v-19.2a3.59 3.59 0 0 1 3.6-3.56l8.31-.02 22.98-.05c1.99 0 3.6 1.6 3.6 3.57zm12.84-9.93a3.59 3.59 0 0 1-3.6 3.57h-1.9c-.51 0-.92.41-.92.91v7.64l-4.58-5V15.37a5.41 5.41 0 0 0-5.44-5.38l-22.06.04V5.38a3.59 3.59 0 0 1 3.6-3.57l31.3.07c1.98 0 3.6 1.6 3.6 3.57v19.19z"/>
                        </svg>
                        <span>{i18n['objectPage.reviews']}</span>
                    </a>

                    <a href="#location">
                        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="47" viewBox="0 0 34 47">
                            <path fill="#ccc"
                                  d="M17.65 10.3a6.03 6.03 0 0 0-6.02 6.01 6.03 6.03 0 0 0 12.05 0c0-3.31-2.7-6.01-6.03-6.01zm0 10.3a4.3 4.3 0 1 1 0-8.6 4.3 4.3 0 0 1 0 8.6zM29.17 4.82A16.45 16.45 0 0 0 17.5 0C13.1 0 8.95 1.72 5.83 4.82.06 10.58-.65 21.4 4.28 27.95L17.5 47l13.2-19.02c4.95-6.58 4.23-17.4-1.53-23.16zm.13 22.16l-11.8 17L5.68 26.95C1.2 21 1.85 11.23 7.05 6.04c2.8-2.79 6.5-4.32 10.45-4.32 3.95 0 7.66 1.53 10.45 4.32 5.2 5.19 5.85 14.96 1.35 20.94z"/>
                        </svg>
                        <span>{i18n['objectPage.location']}</span>
                    </a>
                </div>

                <Description/>

                <div className="separator-dashed"/>

                {this.props.configuration.object.typeApartmentsRent.length > 0 &&
                <Info keyPrefix="generalInformation" info={::this.getGeneralInformationInfo()}/>}

                <Info keyPrefix="other" info={::this.getOtherInfo()}/>

                <div className="separator-dashed"/>

                <div className="rent-rules">
                    <div className="rent-license">
                        {i18n['objectPage.touristLicense']}<br/><span>{license}</span>
                    </div>
                    <div className="rent-rules-content">
                        <h3>{i18n['objectPage.cancellationPolicy']}:</h3>
                        <p>
                            {typeRuleReservations.length > 0 &&
                            ConfigurationUtils.getTypeTitleByValue(cancellationRule, typeRuleReservations)}
                        </p>
                    </div>
                </div>

                <div className="separator-dashed double"/>

                {amenities !== null && amenities !== undefined && amenitiesConf.length > 0 &&
                <Convenience convenience={::this.getConvenience()}/>}

                <div className="separator-dashed"/>

                <div className="rent-comment">
                    <h2>{i18n['objectPage.comment']}</h2>
                    <div className="rent-comment-content">
                        {this.getRentComment()}
                    </div>
                </div>

                <div className="separator-dashed double"/>

                <Reviews/>

                <div className="separator-dashed"/>

                <Location/>

                <div className="separator-dashed double"/>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    objectPage: state.objectPage,
    configuration: state.configuration,
    code: state.languages.currentLanguage.code,
    isShowOriginal: state.objectPage.isShowOriginal,
    amenities: state.objectPage.currentObject.amenities,
    amenitiesConf: state.configuration.object.amenities,
    license: state.objectPage.currentObject.props.license,
    translates: state.objectPage.currentObject.meta.translates,
    rentComment: state.objectPage.currentObject.description.rentComment,
    typeRuleReservations: state.configuration.object.typeRuleReservations,
    cancellationRule: state.objectPage.currentObject.props.cancellationRule
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);



// WEBPACK FOOTER //
// ./src/components/PropertyPage/Rental/MainContainer.js